(ns practitest.frontend.components2.dashboard.charts.readiness-gauge.helpers)

(defn arc [{:config/keys [start-angle end-angle
                          arc-radius arc-weight]}]
  {:from     [:t 0]
   :to       [:t 1]
   :scale    [start-angle end-angle]
   :radius   arc-radius
   :weight   arc-weight
   :corner-r (* arc-weight 0.5)})

(defn tick [{:config/keys
             [tick-length tick-padding tick-inset
              start-angle end-angle
              arc-radius arc-weight]}]
  {:class  "tick"
   :scale  [(+ start-angle tick-inset) (- end-angle tick-inset)]
   :offset (- arc-radius arc-weight tick-padding)
   :length (- tick-length)})

(defn status-icon [{:config/keys [icon-radius]
                    :keys        [readiness-status]}]
  (let [half (* icon-radius 0.5)
        tri  (* icon-radius 1.17)]
    (case readiness-status
      :status/ready
      [:g.label-icon
       [:circle.label-icon-circle {:r icon-radius}]
       [:text.label-icon-text "\u2713"]]
      :status/in-progress
      [:g.label-icon
       [:circle.label-icon-circle {:r icon-radius}]
       [:line.label-icon-dash {:x1 (- half) :y1 0 :x2 half :y2 0}]]
      :status/at-risk
      [:g.label-icon
       [:polygon.label-icon-triangle
        {:points (str "0," (- tri) " " tri "," half " -" tri "," half)}]
       [:text.label-icon-text "!"]])))

